import SettingsIcon from "@mui/icons-material/Settings";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";

const AdvancedSettingsDropdown: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const {
    loadAddresses,
    setLoadAddresses,
    chargeRateOnlyWhenCharging,
    setChargeRateOnlyWhenCharging,
    hideOldData,
    setHideOldData,
    deviceCountLimit,
    setDeviceCountLimit,
  } = useDataGridSettings();

  const { t } = useTranslation();

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        aria-controls={open ? "settings-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleMenuOpen}
        startIcon={<SettingsIcon />}
      >
        {t("faultOverview.advancedSettings")}
      </Button>
      <Menu id="settings-menu" anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem>
          <Tooltip title={t("faultOverview.mayHurtPerformance")}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={deviceCountLimit === 50000}
                  onChange={() => setDeviceCountLimit(prev => (prev === 1000 ? 50000 : 1000))}
                />
              }
              label={t("faultOverview.unlimitedDevices")}
            />
          </Tooltip>
        </MenuItem>
        <MenuItem>
          <Tooltip title={t("faultOverview.mayImprovePerformance")}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={!loadAddresses}
                  onChange={() => setLoadAddresses(prev => !prev)}
                />
              }
              label={t("faultOverview.dontLoadAddresses")}
            />
          </Tooltip>
        </MenuItem>
        {chargeRateOnlyWhenCharging !== undefined && (
          <MenuItem>
            <FormControlLabel
              control={
                <Checkbox
                  checked={chargeRateOnlyWhenCharging}
                  onChange={() => setChargeRateOnlyWhenCharging(prev => !prev)}
                />
              }
              label={t("faultOverview.chargeRateOnlyWhenCharging")}
            />
          </MenuItem>
        )}
        {hideOldData !== undefined && (
          <MenuItem>
            <Tooltip title={t("faultOverview.hideOldDataTooltip")}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={hideOldData}
                    onChange={() => setHideOldData(prev => !prev)}
                  />
                }
                label={t("faultOverview.hideOldDataButton")}
              />
            </Tooltip>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default AdvancedSettingsDropdown;
